import React from 'react'
import SupportInfo from './SupportInfo';

const ErrorInDownload = ({errorMsg}) => {
    return (	
    <div>
        <div className="error-text mt-10">{errorMsg}</div>
            <SupportInfo/>
        </div>
    )
}

export default ErrorInDownload
